export const MultiOwnerModularAccountFactoryAbi = [
    {
        type: "constructor",
        inputs: [
            { name: "owner", type: "address", internalType: "address" },
            {
                name: "multiOwnerPlugin",
                type: "address",
                internalType: "address",
            },
            {
                name: "implementation",
                type: "address",
                internalType: "address",
            },
            {
                name: "multiOwnerPluginManifestHash",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "entryPoint",
                type: "address",
                internalType: "contract IEntryPoint",
            },
        ],
        stateMutability: "nonpayable",
    },
    { type: "receive", stateMutability: "payable" },
    {
        type: "function",
        name: "ENTRYPOINT",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IEntryPoint",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "IMPL",
        inputs: [],
        outputs: [{ name: "", type: "address", internalType: "address" }],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "MULTI_OWNER_PLUGIN",
        inputs: [],
        outputs: [{ name: "", type: "address", internalType: "address" }],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "acceptOwnership",
        inputs: [],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "addStake",
        inputs: [
            { name: "unstakeDelay", type: "uint32", internalType: "uint32" },
            { name: "amount", type: "uint256", internalType: "uint256" },
        ],
        outputs: [],
        stateMutability: "payable",
    },
    {
        type: "function",
        name: "createAccount",
        inputs: [
            { name: "salt", type: "uint256", internalType: "uint256" },
            { name: "owners", type: "address[]", internalType: "address[]" },
        ],
        outputs: [{ name: "addr", type: "address", internalType: "address" }],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "getAddress",
        inputs: [
            { name: "salt", type: "uint256", internalType: "uint256" },
            { name: "owners", type: "address[]", internalType: "address[]" },
        ],
        outputs: [{ name: "", type: "address", internalType: "address" }],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "owner",
        inputs: [],
        outputs: [{ name: "", type: "address", internalType: "address" }],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "pendingOwner",
        inputs: [],
        outputs: [{ name: "", type: "address", internalType: "address" }],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "renounceOwnership",
        inputs: [],
        outputs: [],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "transferOwnership",
        inputs: [{ name: "newOwner", type: "address", internalType: "address" }],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "unlockStake",
        inputs: [],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "withdraw",
        inputs: [
            { name: "to", type: "address", internalType: "address payable" },
            { name: "token", type: "address", internalType: "address" },
            { name: "amount", type: "uint256", internalType: "uint256" },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "withdrawStake",
        inputs: [{ name: "to", type: "address", internalType: "address payable" }],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "event",
        name: "OwnershipTransferStarted",
        inputs: [
            {
                name: "previousOwner",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "newOwner",
                type: "address",
                indexed: true,
                internalType: "address",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "OwnershipTransferred",
        inputs: [
            {
                name: "previousOwner",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "newOwner",
                type: "address",
                indexed: true,
                internalType: "address",
            },
        ],
        anonymous: false,
    },
    { type: "error", name: "InvalidAction", inputs: [] },
    { type: "error", name: "InvalidOwner", inputs: [] },
    { type: "error", name: "OwnersArrayEmpty", inputs: [] },
    { type: "error", name: "OwnersLimitExceeded", inputs: [] },
    { type: "error", name: "TransferFailed", inputs: [] },
];
//# sourceMappingURL=MultiOwnerModularAccountFactory.js.map